<script lang="ts">
	import { headerTypes } from '@/config.ts';
	import { onMount } from 'svelte';

	export let gestalt: string;

	onMount(async () => {
		if (gestalt === 'abo_default' || gestalt === 'abo_service') {
			void (await import('../DstAboSidebar/DstAboSidebar.webcomponent.svelte')).default;
		} else if (gestalt === 'about_default') {
			void (await import('../DstAboutSidebar/DstAboutSidebar.webcomponent.svelte')).default;
		} else if (headerTypes.editorialDe.includes(gestalt)) {
			void (await import('../DstEditorialDeSidebar/DstEditorialDeSidebar.webcomponent.svelte')).default;
		} else if (headerTypes.editorialAt.includes(gestalt)) {
			void (await import('../DstEditorialAtSidebar/DstEditorialAtSidebar.webcomponent.svelte')).default;
		}
	});
</script>

{#if gestalt === 'abo_default' || gestalt === 'abo_service'}
	<dst-abo-sidebar class="app--sidebar" data-closable="app-sidebar" data-closable-active="false">
		<div slot="search">
			<slot name="search" />
		</div>
	</dst-abo-sidebar>
{:else if gestalt === 'about_default'}
	<dst-about-sidebar class="app--sidebar" data-closable="app-sidebar" data-closable-active="false">
		<div slot="search">
			<slot name="search" />
		</div>
	</dst-about-sidebar>
{:else if headerTypes.editorialDe.includes(gestalt)}
	<dst-de-sidebar class="app--sidebar" data-closable="app-sidebar" data-closable-active="false">
		<div slot="search">
			<slot name="search" />
		</div>
	</dst-de-sidebar>
{:else if headerTypes.editorialAt.includes(gestalt)}
	<dst-at-sidebar class="app--sidebar" data-closable="app-sidebar" data-closable-active="false">
		<div slot="search">
			<slot name="search" />
		</div>
	</dst-at-sidebar>
{/if}
